/*
Version 0.110

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	08-03-2019
	- [CHANGE] Added variable check to set height and with when not given in on windowResize();
	11-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_window = {};

(function(){
	 
	
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	//none

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
		/*
		Window: resize
		*/
		this.windowResize = function(scrolled,h,w) {
			
			/*
			Set: Variables
			*/
			if(typeof h === 'undefined') {
				h = $(window).height();
			}
			if(typeof w === 'undefined') {
				w = $(window).width();
			}

			// document.querySelector(':root').style.setProperty('--vh', window.innerHeight/100 + 'px');

			/*
			Page: Scroll to page
			*/			
			if(
				$('.js-settings-ispage').val() == 'true'
			) {
				specific_digidag_menu.scrollToPage(0);
			} else {
				specific_digidag_menu.gotoTour();
			}

			/*
			CTA
			*/
			if(_isDigidagCTA == 1) {
				if(w < 500) {
					$('.js-cta').hide();
				} else {
					$('.js-cta').show();				
				}
			}
			
		};
		
		/*
		Window: scroll
		*/
		this.windowScroll = function(scrolled,h,w) {

		};
		
		
		/*
		Window: orientation
		*/
		this.windowOrientationChange = function() {
			
		};

		/*
		Is in view?
		*/
		this.isInView = function (
			_element,
			_position
		){

		};
		
}).apply(specific_interactions_window); 